import { Typography } from "@mui/material"
import React from "react"
import ReactMarkdown from "react-markdown"

export const MarkdownText = ({ markdownText }) => {

  return (
    <>
    <Typography sx={{textAlign: "justify"}}>
        <ReactMarkdown>{markdownText}</ReactMarkdown>
    </Typography>
    </>
  )
}